import React, { useState } from "react";
import { Chart } from "chart.js/auto"
import { CategoryScale } from "chart.js";
import { Line } from "react-chartjs-2";
import { displayMessage } from "../../services/helper";

import ListPatientsByLevel from '../../components/modals/ListPatientsByLevel'

Chart.register(CategoryScale);

export default function GroupingLevelChart({ groupingLevelChart }) {
    const [patientsByLevel, setPatientsByLevel] = useState([])
    const [isModalPatientsByLevelOpen, setIsModalPatientsByLevelOpen] = useState(false)

    const findPatientsByInterval = (interval) => {
        let id = 0
        let patientsByStars = []
        for (let key in groupingLevelChart) {
            if (key == interval) {
                for (let patient_id in groupingLevelChart[key]) {
                    patientsByStars.push(groupingLevelChart[key][patient_id])
                }
                id++
            }
        }
        setPatientsByLevel(patientsByStars)
    }

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            y: {
                ticks: {
                    stepSize: 1
                }
            }
        },
        plugins: {
            tooltip: {
                callbacks: {
                    label: (context) => {
                        return []
                    },
                    footer: (context) => {
                        for (let key in groupingLevelChart) {
                            if (key === context[0].label) {
                                const count = groupingLevelChart[key].length
                                return [
                                    `${displayMessage*'PATIENT_QUANT'}: ${count}`,
                                ]
                            }
                        }
                    }
                }
            },
        },
        onClick: (event, elements) => {
            setIsModalPatientsByLevelOpen(true)
            findPatientsByInterval(event.chart.tooltip.title[0])
        },
    };

    const data = {
        labels: groupingLevelChart ? Object.keys(groupingLevelChart) : [],
        datasets: [{
            label: displayMessage('GROUPING_BY_LEVEL'),
            data: groupingLevelChart ? Object.values(groupingLevelChart).map(value => value.length) : []
        }]
    };

    return (
        <>
            {data && (
                <Line
                    data={data}
                    width={300}
                    height={300}
                    options={options}
                    style={{ maxHeight: 300 }}
                />
            )}

            <ListPatientsByLevel
                patientsByLevel={patientsByLevel}
                isModalPatientsByLevelOpen={isModalPatientsByLevelOpen}
                setIsModalPatientsByLevelOpen={setIsModalPatientsByLevelOpen}
            />
        </>
    )
}